import { useDispatch } from "react-redux";
import { TasksGrid } from "./TasksGrid";
import { useEffect } from "react";
import { setPageTitle } from "../../store/slices/pageTitleSlice";

export const Tasks = () => {
  const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setPageTitle('Tasks | Spire360'));
    }, []);

  return (
    <>
      <TasksGrid breadcrumbs={true}></TasksGrid>
    </>
  );
};
